
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core';

@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html',
  standalone: false
})
export class PaginationComponent implements OnChanges {
  @Input() totalItems!: number;
  @Input() itemsPerPage!: number;
  @Input() maxSize = 5;
  @Input() rotate = false;
  @Input() directionLinks = true;
  @Input() page = 1;
  @Output() pageChanged = new EventEmitter<{ page: number }>();

  pages: number[] = [];

  showLeftEllipsis = false;
  showRightEllipsis = false;


  ngOnChanges() {
    this.buildPages();
  }

  private buildPages() {
    const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    const currentPage = this.page;
    const maxSize = this.maxSize;

    this.showLeftEllipsis = false;
    this.showRightEllipsis = false;

    if (totalPages <= maxSize) {
      this.pages = Array.from({ length: totalPages }, (_, i) => i + 1);
      return;
    }

    let startPage: number;
    let endPage: number;

    if (this.rotate) {
      const half = Math.floor(maxSize / 2);
      startPage = Math.max(currentPage - half, 1);
      endPage = startPage + maxSize - 1;

      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = endPage - maxSize + 1;
      }

    } else {
      const pageGroup = Math.ceil(currentPage / maxSize) - 1;
      startPage = pageGroup * maxSize + 1;
      endPage = Math.min(startPage + maxSize - 1, totalPages);
    }

    this.showLeftEllipsis = startPage > 1;
    this.showRightEllipsis = endPage < totalPages;

    this.pages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  selectPage(page: number) {
    this.page = page;
    this.pageChanged.emit({ page });
  }


  goToNextBlock() {
    const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    const nextPage = Math.min(this.pages[this.pages.length - 1] + 1, totalPages);

    this.selectPage(nextPage);
  }

  goToPrevBlock() {
    const prevPage = Math.max(this.pages[0] - 1, 1);

    this.selectPage(prevPage);
  }
}
